import axios from "axios";
import { localStorageItem } from "../../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../../auth/core/_consts";

const API_PATH = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"];

type TExportParams = {
    id?: string;
};

export const exportTopicReviewScience = (params: TExportParams) => {
    let url = `${API_PATH}/export/topic-review/science`;
    return axios.post<Blob>(url, params, { responseType: 'blob' });
};

export const exportRecordScience = (params: TExportParams) => {
    let url = `${API_PATH}/export/record/science`;
    return axios.post<Blob>(url, params, { responseType: 'blob' });
};

export const exportAssignmentDecision = (params: TExportParams) => {
    let url = `${API_PATH}/export/assignment/decision`;
    return axios.post<Blob>(url, params, { responseType: 'blob' });
};
